import {RootState} from '../../store';
import {Customer} from './types';

export const selectionSelector = (state: RootState): Record<string, Customer> =>
    state['customers'].selection as Record<string, Customer>;
